<template>
  <Card>
    <h1 slot="Title">General Ledger Structure</h1>
    <div slot="MainContent">
      <p>
        <b>Account Categories and Definitions</b>: There are seven major categories in the USSGL.  These are further classified as real, nominal, budgetary, and / or proprietary accounts.
      </p>
      <ul>
        <li>
         <b>Real Accounts</b>: Balance sheet accounts which remain open and are available during the business life cycle.  Asset, liability, and net position accounts are classified as real accounts.
        </li>
        <li>
          <b>Nominal Accounts</b>: Accounts which are closed at fiscal year-end or at the end of the accounting period.  Expenses, revenues, and gains / losses / extraordinary items are classified as nominal accounts.
        </li>
        <li>
          <b>Budgetary Resource Accounts</b>: Used in conjunction with real and nominal accounts.  Budgetary resource accounts track budgetary execution and funding and serve to meet the fiscal requirements of appropriation managers. GLACs numbered 4*** are classified as budgetary accounts.
        </li>
        <li>
          <b>Proprietary Accounts</b>: Those which present the financial position of the government operation. They serve primarily for the production of financial reports to meet the needs of internal financial managers and external users. Proprietary accounts include all GLACs except the budgetary accounts. 
        </li>
      </ul>
    </div>
    <p><strong>General Ledger Structure</strong></p>
    <p>Instructor notes:&nbsp; Have the students read the terms.&nbsp;&nbsp;</p>
    <p><strong>Now that we have looked at these accounts,</strong><strong> lets associate them to the </strong><strong>General Ledger Structure.&nbsp; Emphasize which accounts fall in each further classified accounts:</strong></p>
    <p>Real Accounts = asset, liability and net position account</p>
    <p>Nominal Accounts = expenses, revenues, gains, losses, and extraordinary items.</p>
    <p>Budgetary Resource Accounts =&nbsp; GLACs numbered 4***</p>
    <p>Proprietary Accounts = -include all GLACs except the budgetary accounts.&nbsp;</p>
    <p>The USSGL accounting process encompasses both proprietary and budgetary data.&nbsp; This integrated process is built upon the detailed principles and procedures prescribing how accounting events are measured, recorded, classified, summarized and reported<em>.</em></p>
  </Card>
</template>
<style scoped>


</style>
<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'GeneralLedgerStructure',
  
  data() {
    return {
      Image: require('@/assets/The Basic 6-Digit USSGL Accounts Classification_150ppi.png')
    }
  }
  
}
</script>